import { Form } from "@inertiajs/react";
import Button from "@/components/buttons/Button";
import Input from "@/components/inputs/Input";
import InertiaLink from "@/components/buttons/InertiaLink";
import PageHeader from "@/components/PageHeader";
import SearchSelect from "@/components/inputs/SearchSelect";
import FormActions from "@/components/buttons/FormActions";

const New: React.FC = () => {
  return (
    <div className="flex w-full flex-col items-start justify-start gap-10">
      <PageHeader
        backLink={{ href: "/artists", text: "Back to all artists" }}
        title="Create new artist"
      />
      <Form
        action="/artists"
        method="post"
        className="md:dark:bg-cream-950 flex w-full flex-col gap-6 rounded-lg md:bg-white md:p-10 md:shadow"
      >
        {({ processing, errors }) => (
          <>
            <Input
              type="text"
              label="Name *"
              name="artist[name]"
              placeholder="Enter artist name"
              errors={errors.name}
            />

            <SearchSelect
              label="Contributors"
              name="contributor_ids[]"
              placeholder="Search for contributors"
              reloadPropName="contributor_search_results"
              queryParam="contributor_q"
              errors={errors.contributor_ids}
            />

            <FormActions>
              <InertiaLink href="/artists" type="secondary" text="Cancel" />
              <Button
                text={processing ? "Creating..." : "Create Artist"}
                type="primary"
                htmlButtonType="submit"
                disabled={processing}
              />
            </FormActions>
          </>
        )}
      </Form>
    </div>
  );
};

export default New;
